import React from 'react';
import CategorySection from '../components/CategorySection'; // Import the CategorySection component
import '../../style/components/FormView.css'; // Import the updated CSS module

const Pension = () => {
  // Data for category sections
  const pension = [
    { href: "/pensionSr", text: "Pension Senior College" },
  ];
 const pensionjr =  [
    { href: "/pensionHighSchool", text: "Pension Junior College" },
  ];

  return (
    <div className="FormView">
      <h1 className="page-title">Pension</h1>

      <div>
        <div className="section-container">
          {/* Non Agricultural Teaching Section */}
          <CategorySection 
            title="Senior College"
            links={pension}
          />

          {/* Divider */}
          <div className="divider"></div>

          {/* Non Agricultural Non-Teaching Section */}
          <CategorySection 
            title="High School"
            links={pensionjr}
          />
        </div>
      </div>
    </div>
  );
};

export default Pension;
